export default __webpack_public_path__ + "static/media/Skylance.d88ec01f.jpg";